import {
  clampPage,
  computePageCount,
  normalizePageAfterPageSizeChange,
  normalizePageAfterQueryChange,
  resolvePageAfterDelete
} from '../services/api/pagedQuery';

export const PAGED_GRID_ACTIONS = {
  SET_LOADING: 'SET_LOADING',
  SET_PAGE: 'SET_PAGE',
  SET_PAGE_SIZE: 'SET_PAGE_SIZE',
  SET_SEARCH: 'SET_SEARCH',
  SET_FILTERS: 'SET_FILTERS',
  SET_SORT: 'SET_SORT',
  SET_DATA: 'SET_DATA',
  SET_ERROR: 'SET_ERROR',
  RESTORE_STATE: 'RESTORE_STATE'
};

export function createInitialPagedGridState({
  page = 1,
  pageSize = 10,
  search = '',
  filters = {},
  sort = null,
  direction = null
} = {}) {
  return {
    page,
    pageSize,
    search,
    filters,
    sort,
    direction,
    items: [],
    totalCount: 0,
    pageCount: 1,
    loading: false,
    error: null,
    forcePage: page - 1
  };
}

export function pagedGridReducer(state, action) {
  switch (action.type) {
    case PAGED_GRID_ACTIONS.SET_LOADING:
      return { ...state, loading: action.loading, error: action.loading ? state.error : state.error };
    case PAGED_GRID_ACTIONS.SET_PAGE:
      return { ...state, page: action.page, forcePage: action.page - 1 };
    case PAGED_GRID_ACTIONS.SET_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.pageSize,
        page: normalizePageAfterPageSizeChange(),
        forcePage: 0
      };
    case PAGED_GRID_ACTIONS.SET_SEARCH:
      return {
        ...state,
        search: action.search,
        page: normalizePageAfterQueryChange(),
        forcePage: 0
      };
    case PAGED_GRID_ACTIONS.SET_FILTERS:
      return {
        ...state,
        filters: action.filters,
        page: normalizePageAfterQueryChange(),
        forcePage: 0
      };
    case PAGED_GRID_ACTIONS.SET_SORT:
      return {
        ...state,
        sort: action.sort,
        direction: action.direction,
        page: normalizePageAfterQueryChange(),
        forcePage: 0
      };
    case PAGED_GRID_ACTIONS.SET_DATA: {
      const page = clampPage({
        page: action.page ?? state.page,
        totalCount: action.totalCount,
        pageSize: action.pageSize ?? state.pageSize
      });
      return {
        ...state,
        items: action.items,
        totalCount: action.totalCount,
        page,
        pageSize: action.pageSize ?? state.pageSize,
        pageCount: computePageCount(action.totalCount, action.pageSize ?? state.pageSize),
        loading: false,
        error: null,
        forcePage: page - 1
      };
    }
    case PAGED_GRID_ACTIONS.SET_ERROR:
      return { ...state, loading: false, error: action.error };
    case PAGED_GRID_ACTIONS.RESTORE_STATE:
      return {
        ...state,
        ...action.state,
        forcePage: (action.state.page ?? state.page) - 1
      };
    default:
      return state;
  }
}

export function pageAfterDelete(state, itemsOnCurrentPage) {
  const totalPages = computePageCount(state.totalCount, state.pageSize);
  return resolvePageAfterDelete({
    currentPage: state.page,
    totalPages,
    itemsOnCurrentPage
  });
}

export function buildPagedGridQuery(state) {
  return {
    page: state.page,
    pageSize: state.pageSize,
    search: state.search || undefined,
    sort: state.sort || undefined,
    direction: state.direction || undefined,
    filters: state.filters
  };
}
